// src/utils/tokenImage.js
//
// Per-token artwork was only ever rendered for ids 1..999 (3-digit, zero-padded).
// Tokens 1000+ exist on-chain (airdropped above the high-water mark) but have no
// /small/NNNN.jpg asset, so they fall back to the shared collection art.

const PER_TOKEN_ART_MAX_ID = 999;

const SHARED_COLLECTION_IMAGE =
  'https://nft.sogni.ai/big/badge-fast-worker-prospect/001.jpg';

/**
 * Thumbnail URL for a worker NFT id.
 * @param {number|string} tokenId
 * @returns {string} per-token thumbnail for ids <= 999, shared art above that
 */
export function getTokenImageUrl(tokenId) {
  const id = Number(tokenId);
  if (!Number.isFinite(id) || id <= 0 || id > PER_TOKEN_ART_MAX_ID) {
    return SHARED_COLLECTION_IMAGE;
  }
  return `https://nft.sogni.ai/small/${String(id).padStart(3, '0')}.jpg`;
}

export { PER_TOKEN_ART_MAX_ID, SHARED_COLLECTION_IMAGE };
